module.exports = __webpack_public_path__ + "img/btn1_bg.a3865bcc.png";